// extracted by mini-css-extract-plugin
export default {"details":"article-owner_details__Kt6lR","job":"article-owner_job__VBmph","articleOwner":"article-owner_articleOwner__phwMV"};